// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UserAddOutlinedSvg from "@ant-design/icons-svg/es/asn/UserAddOutlined";
import AntdIcon from '../components/AntdIcon';

var UserAddOutlined = function UserAddOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UserAddOutlinedSvg
  }));
};

UserAddOutlined.displayName = 'UserAddOutlined';
export default React.forwardRef(UserAddOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/UserAddOutlined.js
// module id = 2007
// module chunks = 0